import React, { createContext, useState, useContext, useEffect } from 'react';
import { favouritesAPI } from '../lib/api';
import { useAuth } from './AuthContext';
import { toast } from 'sonner';
import { logger } from '../lib/logger';

const FavouritesContext = createContext();

export const useFavourites = () => useContext(FavouritesContext);

export const FavouritesProvider = ({ children }) => {
  const [favourites, setFavourites] = useState([]);
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      fetchFavourites();
    } else {
      setFavourites([]);
    }
  }, [isAuthenticated]);

  const fetchFavourites = async () => {
    try {
      const response = await favouritesAPI.getFavourites();
      setFavourites(response.data);
    } catch (err) {
      logger.error('Failed to fetch favourites:', err);
    }
  };

  const isFavourite = (planId) => favourites.includes(planId);

  const toggleFavourite = async (planId) => {
    if (!isAuthenticated) {
      toast.error('Please sign in to favourite plans');
      return false;
    }
    try {
      if (isFavourite(planId)) {
        await favouritesAPI.removeFavourite(planId);
        setFavourites(prev => prev.filter(id => id !== planId));
        toast.success('Removed from favourites');
      } else {
        await favouritesAPI.addFavourite(planId);
        setFavourites(prev => [...prev, planId]);
        toast.success('Added to favourites');
      }
      return true;
    } catch (err) {
      toast.error('Failed to update favourites');
      return false;
    }
  };

  return (
    <FavouritesContext.Provider value={{ favourites, isFavourite, toggleFavourite }}>
      {children}
    </FavouritesContext.Provider>
  );
};
